/**
 * Utility functions and helpers for the Redfox Thank You plugin.
 */

// Attribute Manager
export type {
	AttributeManager,
	BlockAttributes,
	CreateAttributeManagerFunction,
	GetAttributeFunction,
	SetAttributesFunction,
	UpdateAttributesFunction,
} from './attribute-manager';
export {
	createAttributeManager,
	getAttribute,
	updateAttributes,
} from './attribute-manager';

// Style Helper
export {
	convertBorderToCSS,
	convertMarginToCSS,
	convertPaddingToCSS,
	ensureUnit,
	generateCSSFromAttributes,
	generateInlineStyles,
} from './style-helper';
export type {
	BorderControlValue,
	BoxControlValue,
	StyleAttributes,
} from './style-helper/types';

// Style Renderer
export {
	getEditorCanvasDocument,
	injectStyleIntoDocuments,
	removeStyleElements,
	StyleRenderer,
	watchForIframeChanges,
} from './style-renderer';
